import React from 'react';

import { BackButton } from './back-button';

interface ScreenHeaderProps {
  handleBack?: () => void;
  steps?: number;
  step?: number;
  title: string;
  description: string;
}

export function ScreenHeader({ handleBack, steps, step, title, description }: ScreenHeaderProps) {
  return (
    <div className="screen-header">
      <div className="screen-title">
        {
          handleBack && 
            <div className="screen-header-back-button">
              <BackButton 
                handleBack={handleBack} 
                dark={false} 
                hasText={false} 
                size="large" 
              />
            </div>
        }
        <h2>{title}</h2>
      </div>
      <div>
        <p>{description}</p>
      </div>
      {
        steps && (
          <>
            <div className="progress-info">
              <p>Step {step} of {steps}</p>
              <p>{Math.floor((step - 1) / steps * 100)}% Complete</p>
            </div>
            <div className="progress-bar">
              <div className="progress-bar-fill" style={{ width: `calc(100%/${steps}*${step})` }}></div>
            </div>
          </>
        )
      }
    </div>
  );
}
